import { render, staticRenderFns } from "./expertSeminar.vue?vue&type=template&id=f5c4f992&"
import script from "./expertSeminar.vue?vue&type=script&lang=js&"
export * from "./expertSeminar.vue?vue&type=script&lang=js&"
import style0 from "./expertSeminar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports